import './TaskSection.scss';
import { BarsOutlined } from '@ant-design/icons';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { coreActions } from '@sonar-software/sonar-core';
import { CreateTask } from './CreateTask';
import { DeleteTaskNotification } from './DeleteTaskNotification';
import { InitiativeSection } from '../general';
import { InitiativeTask } from './Task';
import React from 'react';
import { UpdateTaskNotification } from './UpdateTaskNotification';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import { useAction, useInitiativeTasks } from '@hooks';
export const TaskSection = ({ initiativeId }) => {
    const { tasks } = useInitiativeTasks(initiativeId, true);
    const orderTasks = useAction(coreActions.requestPostCoreInitiativesTasksOrder);
    const handleOnDragEnd = (dropResult) => {
        const { destination, source } = dropResult;
        if (!source || !destination) {
            return;
        }
        orderTasks({
            initiativeId,
            sourceIndex: source.index,
            targetIndex: destination.index
        });
    };
    return (React.createElement(InitiativeSection, { count: tasks === null || tasks === void 0 ? void 0 : tasks.length, icon: React.createElement(BarsOutlined, null), id: 'initiative-tasks-section', title: COPY_SPECIFIC.TASKS },
        React.createElement(DragDropContext, { onDragEnd: handleOnDragEnd },
            React.createElement(Droppable, { droppableId: 'tasks' }, (provided) => React.createElement("div", Object.assign({ ref: provided.innerRef }, provided.droppableProps), tasks === null || tasks === void 0 ? void 0 :
                tasks.map((task, index) => {
                    const { initiativeTaskId } = task;
                    return React.createElement(InitiativeTask, { index: index, key: initiativeTaskId, task: task });
                }),
                provided.placeholder))),
        React.createElement(CreateTask, { initiativeId: initiativeId }),
        React.createElement(DeleteTaskNotification, null),
        React.createElement(UpdateTaskNotification, null)));
};
